import { useEffect, useState } from 'react';
import { fetchTenantHierarchy, type TenantHierarchyNode } from '@/api/tenantHierarchy';

/**
 * Ticket 124.6c — loads the caller's tenant hierarchy (for parent
 * detection). On error it resolves to an empty list so callers treat
 * the tenant as a leaf (the subtree view stays hidden).
 */
export function useTenantHierarchy(enabled = true) {
  const [nodes, setNodes] = useState<TenantHierarchyNode[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setNodes([]);
      return;
    }
    let active = true;
    setLoading(true);
    fetchTenantHierarchy()
      .then((data) => {
        if (active) setNodes(data);
      })
      .catch(() => {
        if (active) setNodes([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [enabled]);

  return { nodes, loading };
}
